import cn from "classnames";

export interface BoardTab {
  id: string;
  label: string;
  icon: React.ComponentType<{ size: number; color: string }>;
}

interface BoardTabsProps {
  items: BoardTab[];
  activeId: string;
  onChange: (id: string) => void;
}

export default function BoardTabs({ items, activeId, onChange }: BoardTabsProps) {
  return (
    <div className="p-6 radius-3xl surface-base-fill flex flex-wrap justify-start items-center gap-2">
      {items.map((item) => {
        const isActive = item.id === activeId;
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange(item.id)}
            className={cn(
              "px-3 py-2.5 flex justify-start items-center gap-2 radius-sm text-label-md cursor-pointer",
              isActive ? "background-brand-fill text-white" : "surface-component-fill content-action-neutral",
            )}>
            <Icon size={20} color="currentColor" />
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
